import React from 'react';
import PropTypes from 'prop-types';

import { Show } from '../../../show';

import Spacer from '../../../spacer';

import MathContent from '../../../math-content';

import { VALIDATION_STATUSES, AND, getCdesCorrection } from '../../../../lib/checker';
import { CORRECT, MISSING, WRONG } from '../../../../lib/exercise';
import styled from 'styled-components';

const CDE_FEEDBACK_LABELS = {
    [MISSING]: 'Condizioni di esistenza mancanti.',
    [WRONG]: 'Condizioni di esistenza sbagliate.',
    [CORRECT]: 'Condizioni di esistenza esatte.',
};

const Label = styled.strong`
    padding-right: ${(props) => props.theme.space.xs}px;
`;

export const CdeSolutions = ({ existenceConditions }) => {
    return (
        <div>
            <Label>{'Le condizioni di esistenza esatte sono:'}</Label>
            <MathContent style={{ display: 'inline-block' }} parseContent={false}>
                {existenceConditions.join(`&nbsp; ${AND} &nbsp;`)}
            </MathContent>
        </div>
    );
};

CdeSolutions.propTypes = {
    existenceConditions: PropTypes.array,
};

const CdeFeedback = ({ exercise, answers, children }) => {
    const { cdes = [] } = answers;
    const { validationStatus } = cdes.find((cde) => cde) || {};

    const cdeCorrection = getCdesCorrection(cdes);

    if (exercise.existenceConditions.length > 0) {
        return (
            <div>
                <Label>{CDE_FEEDBACK_LABELS[cdeCorrection]}</Label>
                {cdeCorrection === MISSING && <span>{`Se le condizioni sono mancanti o sbagliate, l’esercizio è sempre sbagliato.`}</span>}
                {children}
                <Show when={validationStatus !== VALIDATION_STATUSES.VALID}>
                    <CdeSolutions existenceConditions={exercise.existenceConditions} />
                </Show>
                <Spacer size="regular" />
            </div>
        );
    }

    return <></>;
};

CdeFeedback.propTypes = {
    answers: PropTypes.array,
    exercise: PropTypes.object,
    children: PropTypes.node,
};

export default CdeFeedback;
